import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const changeInfoValidationSchema = Yup.object().shape({
  fullName: Yup.string().required(SystemMessage.FULL_NAME_REQUIRED),
  email: Yup.string()
    .required(SystemMessage.INPUT_REQUIRED)
    .email(SystemMessage.EMAIL_ADDRESS_INVALID),
});

export const changePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  newPassword: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  confirmPassword: Yup.string()
    .required(SystemMessage.CONFIRM_PASSWORD_REQUIRED)
    .oneOf([Yup.ref("newPassword")], SystemMessage.CONFIRM_PASSWORD_INVALID),
});
